import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import SignUpTabs from "../Components/SignUpTabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const PhysicianSignUp = () => {
	// eye
	const [passwordVisibility, setPasswordVisibility] = useState({
		firstPassword: false,
		secondPassword: false,
	});

	const togglePasswordVisibility = (field) => {
		setPasswordVisibility((prevVisibility) => ({
			...prevVisibility,
			[field]: !prevVisibility[field],
		}));
	};
	return (
		<>
			<Header />
			<PageHeader pagename="SignUp" />
			<section className="signup">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="signup-wrappper">
								<h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
									Sign up
								</h2>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="d-flex align-items-center justify-content-center">
											<SignUpTabs />
										</div>
									</div>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-6">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													First Name
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder=" First Name"
												/>
											</label>
										</div>
										<div className="form-group col-lg-6">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Last Name
												</h5>
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder=" Last Name"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">Email</h5>
												<input
													type="email"
													className="form-control"
													id="firstName"
													placeholder=" Email"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Work Contact
												</h5>
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Enter Phone"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="">
												<h5 className="primary-medium-font level-7 ">
													Work Address{" "}
												</h5>
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Enter Work Address"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-4">
											<label htmlFor="">
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder="City"
												/>
											</label>
										</div>
										<div className="form-group col-lg-4">
											<label htmlFor="">
												<input
													type="text"
													className="form-control"
													id="firstName"
													placeholder="state"
												/>
											</label>
										</div>
										<div className="form-group col-lg-4">
											<label htmlFor="">
												<input
													type="number"
													className="form-control"
													id="firstName"
													placeholder="Zip Code"
												/>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="firstPassword">
												<h5 className="primary-medium-font level-7">
													Password
												</h5>
												<div className="password-container">
													<input
														type={
															passwordVisibility.firstPassword
																? "text"
																: "password"
														}
														className="form-control"
														id="firstPassword"
														placeholder="********"
													/>
													<span
														className="eye-icon"
														onClick={() =>
															togglePasswordVisibility("firstPassword")
														}
													>
														<FontAwesomeIcon
															icon={
																passwordVisibility.firstPassword
																	? faEyeSlash
																	: faEye
															}
														/>
													</span>
												</div>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-12">
											<label htmlFor="secondPassword">
												<h5 className="primary-medium-font level-7">
													Confirm Password
												</h5>
												<div className="password-container">
													<input
														type={
															passwordVisibility.secondPassword
																? "text"
																: "password"
														}
														className="form-control"
														id="secondPassword"
														placeholder="********"
													/>
													<span
														className="eye-icon"
														onClick={() =>
															togglePasswordVisibility("secondPassword")
														}
													>
														<FontAwesomeIcon
															icon={
																passwordVisibility.secondPassword
																	? faEyeSlash
																	: faEye
															}
														/>
													</span>
												</div>
											</label>
										</div>
									</div>
									<Link
										className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										to="/physician-signup-detail"
									>
										<span className="bg-wrapper w-100">
											Proceed to Next Step
										</span>
									</Link>
									<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
										Already have an account?{" "}
										<Link
											to="/sign-in"
											className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
										>
											Sign In
										</Link>
									</h4>
								</form>
							</div>
						</div>
						<h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
							By Becoming a member, you agree to our{" "}
							<Link
								to="/terms-of-service"
								className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
							>
								Terms & Conditions
							</Link>
						</h4>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianSignUp;
